import React, { ReactNode } from 'react';

import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import { PreventOverscroll } from '../atoms/prevent-overscroll';

//TODO - use touch backend for mobile apps
export function GlobalContext({ children }: { children: ReactNode }) {
	return (
		<DndProvider backend={HTML5Backend}>
			<PreventOverscroll />
			{children}
		</DndProvider>
	);
}
